export const splitFullName = (fullName: string) => {
  const match = fullName.trim().match(/^(\S+)\s*(.*)$/);
  if (!match) {
    return { firstName: fullName, lastName: fullName };
  }

  return { firstName: match[1], lastName: match[2] };
};
